<template>
    <v-dialog v-model="dialog" width="600">
      <v-card>
        <v-card-title class="headline">
          Notatki
        </v-card-title>
        <v-card-text>
          <v-form
              ref="newForm"
              lazy-validation
              class="dimension--form mt-5 mb-5"
          >
            <v-row>
              <v-col cols="12" md="12" align-self="start" dense>
                <Notes
                    :id="this.id"
                    url-add="/api/companies/{parentId}/notes"
                    url-delete="/api/companies/{parentId}/notes/{id}"
                    url-update="/api/companies/{parentId}/notes/{id}"
                    url-list="/api/companies/{parentId}/notes"
                ></Notes>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>

import Notes from "@/components/notes/Notes.vue";

export default {
  name: 'ModalAddNote',
  components: {Notes},
  mixins: [
  ],
  created() {
  },
  data: () => ({
    dialog: false,
    sendEmailUser: null,
    users: [],
    id: null,
  }),
  methods: {
    open(id) {
      this.id = id;
      this.dialog = true;
    },
  },
}
</script>

<style scoped></style>
